import { useState } from 'react';
import type { GridRowParams } from '@mui/x-data-grid-premium';
import { useAppDispatch } from 'hooks';
import { Status } from 'consts/users';
import { when } from 'util/support';
import type { User } from 'features/users/types';
import { updateUser } from 'features/users/slice';
import useUserActions from "features/users/useActions";
import { SwitchableAction } from "ui/molecules/Action";

const ToggleActive = (props: GridRowParams<User>) => {
    const [isProcessing, setProcessing] = useState(false);

    const dispatch = useAppDispatch();

    const { updateOrCreateUser } = useUserActions();

    const updateStatus = async (isChecked: boolean) => {
        setProcessing(true);

        const response = await updateOrCreateUser({
            coreId: props.row.coreId,
            status: when(
                isChecked,
                Status.Active,
                Status.Inactive
            )
        }, {
            shouldNotifyOnSuccess: true
        });

        setProcessing(false);

        dispatch(updateUser(response.data));

        return response;
    };

    const getChecked = (params: GridRowParams<User>) => (
        params.row.status !== Status.Inactive
    );

    const defaultDialogContent = {
        dialogContent: [
            `Are you sure you would like to change status to ${when(
                getChecked(props),
                'Inactive',
                'Active'
            )}?`
        ],
        actionContent: 'Yes'
    };

    return (
        <SwitchableAction
            undoableDialog={{
                handleProcess: updateStatus,
                i18n: [<></>],
                getDefaultChecked: () => getChecked(props)
            }}
            ConfirmatableDialogProps={{
                isProcessing,
                checkPredicate: () => false,
                content: [
                    defaultDialogContent,
                    defaultDialogContent
                ],
                cancelActionContentSlot: 'No'
            }}
        />
    );
};

export default ToggleActive;
